import { useDispatch, useSelector } from "react-redux";
import "../assets/css/modal.css";
import { setAlertModal } from "../redux/features/modalAlert.js/modalSlice";

const AlertModal = () => {
  const alert = useSelector((state) => state.modal?.alertModal);
  const verifybundleStatus =  useSelector((state) => state?.oxygenRetail?.verifyBundleStatus?.status);
  
  const dispatch = useDispatch();
  const closeModal = () => {
    if (alert?.action) {
      alert?.action();
    }
    dispatch(
      setAlertModal({
        status: false,
        message: "",
        type: "",
        heading: "",
        btnText: "Close",
      })
    );
  };

  return (
    alert?.status && (
      <div className="alert-modal alertPOP">
        <div className="alert-modal-overlay"></div>
        <div className="alert-modal-card vivify popInBottom">
          <div className="close-alert-button"></div>

          <div className="alert-modal-body">
            <br />
            {alert?.header && (
              <>
              <div
                style={{ padding: "17px" }}
                className={`alert-modal-icon ${
                  alert.type === "success" ? "bg-success" : "bg-danger"
                }`}
              >
                {alert.type === "success" ? (
                  <i className="ti-check"></i>
                ) : (
                  <i className="ti-close"></i>
                )}
              </div>
              <h4
                className={
                  alert.type === "success" ? "text-success" : "text-danger"
                }
              >
                {alert.type === "success" ? "SUCCESS" : "Operation Failed!!!"}
              </h4>
              </>
            )} 

            <p
              className={`${alert.type === "success" ? "success" : "error"}`}
              style={{ lineHeight: "32px" }}
            >
              {alert.message}
            </p>

            <div className="alert-modal-button mt-3" style={{display: "flex", flexDirection:"row", justifyContent:"space-between"}}>
              {alert?.cancelBtn && (
                 <button
                 onClick={() =>
                   dispatch(
                     setAlertModal({
                       status: false,
                       message: "",
                       type: "",
                       heading: "",
                     })
                   )
                 }
                 className="btn btn-dark border py-3 mr-3"
               >
                 Cancel
               </button>
              )}
             
              <button
                disabled={verifybundleStatus ?? false}
                onClick={() => closeModal()}
                className="btn btn-primary border py-3"
              >
                {alert?.btnText}
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default AlertModal;
